import toast from "react-hot-toast";
import Swal from "sweetalert2";
import * as yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import { BANK_PAYMENT_METHODS, monthOrder } from "./Constants";

// export const toastStyle = { background: "#333", color: "#fff", align: "left" };
export const toastStyle = { background: "#fff", color: "#333", align: "left" };

export const formValidator = (values) => {
  const errors = {};
  const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%?]).{8,24}$/i;

  if (values.email && !emailRegExp.test(values.email)) {
    errors.email = "invalidEmail";
  }

  if (values.password && !passwordRegExp.test(values.password)) {
    errors.password = "invalidPassword";
  }

  if (values.confirmPassword && values.confirmPassword !== values.password) {
    errors.confirmPassword = "passwordMismatch";
  }

  if (!values.type) {
    errors.type = "typeRequired";
  }

  if (!values.taxCode) {
    errors.taxCode = "taxCodeRequired";
  }

  if (!values.affiliateCode) {
    errors.affiliateCode = "affiliateCodeRequired";
  }

  if (!values.name) {
    errors.name = "firstnameRequired";
  }

  if (!values.surName) {
    errors.surName = "lastnameRequired";
  }

  if (!values.dateOfBirth) {
    errors.dateOfBirth = "dobRequired";
  }

  if (!values.sex) {
    errors.sex = "sexRequired";
  }

  if (!values.placeOfBirth) {
    errors.placeOfBirth = "birthPlaceRequired";
  }

  if (!values.provinceOfBirth) {
    errors.provinceOfBirth = "birthCountryRequired";
  }

  if (!values.mobilePhone) {
    errors.mobilePhone = "mobileNumberRequired";
  }

  if (!values.address) {
    errors.address = "residenceAddressRequired";
  }

  if (!values.city) {
    errors.city = "residenceCityRequired";
  }

  if (!values.province) {
    errors.province = "residenceCountryRequired";
  }

  if (!values.postcode) {
    errors.postcode = "residencePostcodeRequired";
  }

  if (!values.addressHome) {
    errors.addressHome = "domicileAddressRequired";
  }

  if (!values.cityHome) {
    errors.cityHome = "domicileCityRequired";
  }

  if (!values.provinceHome) {
    errors.provinceHome = "domicileCountryRequired";
  }

  if (!values.postcodeHome) {
    errors.postcodeHome = "domicilePostcodeRequired";
  }

  return errors;
};

export const toastMessage = (message) => {
  toast(message, { icon: "👏", duration: 5000, style: toastStyle });
};

export const swalMessage = (message) => {
  Swal.fire({
    title: message,
    // showConfirmButton: false,
    timer: 5000,
  });
};

export const toastSuccess = (message) => {
  toast.success(message, { duration: 5000, style: toastStyle });
};

export const swalSuccess = (message) => {
  Swal.fire({
    icon: "success",
    title: message,
    timer: 5000,
  });
};

export const toastError = (err, serverNotResponding = "") => {
  console.log(err);
  let errorMessage = err?.data?.error ?? serverNotResponding;
  errorMessage = err?.error?.data?.message ?? errorMessage;
  errorMessage = err?.error?.data?.error ?? errorMessage;
  errorMessage = err?.data?.message ?? errorMessage;
  errorMessage = err?.data?.err ?? errorMessage;
  errorMessage = err?.data?.msg ?? errorMessage;
  toast.error(errorMessage, { duration: 5000, style: toastStyle });
};

export const swalError = (err, serverNotResponding = "") => {
  console.log(err);
  let errorMessage = err?.data?.error ?? serverNotResponding;
  errorMessage = err?.error?.data?.message ?? errorMessage;
  errorMessage = err?.error?.data?.error ?? errorMessage;
  errorMessage = err?.data?.message ?? errorMessage;
  errorMessage = err?.data?.err ?? errorMessage;
  errorMessage = err?.data?.msg ?? errorMessage;
  Swal.fire({
    icon: "error",
    title: errorMessage,
    timer: 5000,
  });
};

export const getReferralFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("referral");
};

export const formatNumberToLocal = (number = 0, decimal = 2) => {
  const num = parseFloat(number);

  if (!isNaN(num)) {
    if (num % 1 === 0) {
      return num.toLocaleString("en-US", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    } else {
      return num.toFixed(decimal).toLocaleString("en-US", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    }
  } else {
    return "0.00";
  }
};

export const hOneCalculation = (StaticValue, inputData, ingots) => {
  let duration = parseInt(inputData.duration);
  let goldCost = 0;
  let storageValue = 0;
  let storageCost = 0;
  let spreadValue = 0;
  let costSpread = 0;
  let totalManufacturingCost = 0;
  let totalCost = 0;
  let total_gr = 0;
  let goldPriceWithMargin = 0;
  let costSpreadWithMargin = 0;
  let storageCostWithMargin = 0;
  let manufacturingCostWithMargin = 0;
  let goldPriceWithGuaranteeMargin = 0;
  let costSpreadWithGuaranteeMargin = 0;
  let storageCostWithGuaranteeMargin = 0;
  let bank_transfer = 0;
  let total_payment_with_margin = 0;
  let total_payment_with_guarantee_margin = 0;
  let homeDelivery = inputData.type === "home_delivery" ? true : false;

  const hOneDettaglios = ingots;
  // const isHaveQuantity = hOneDettaglios.some((item) => item.quantity > 0);
  const isHaveQuantity = true;

  if (isHaveQuantity) {
    const goldFixingPerGramValue = StaticValue.goldValue[0]?.value || 0;

    for (const item of hOneDettaglios) {
      const { ingot, quantity } = item;

      const manufacturingCost =
        StaticValue.manufacturingCost.find((item) => item.ingot === `${ingot}gr`)?.cost || 0;

      const goldCost = ingot * goldFixingPerGramValue * quantity;

      item.manufacturingCost = quantity ? manufacturingCost * quantity : 0;
      item.goldCost = quantity ? goldCost : 0;
      item.totalCost = quantity ? item.manufacturingCost + goldCost : 0;
    }

    total_gr = hOneDettaglios.reduce(
      (total, item) => total + item.ingot * item.quantity,
      0
    );

    if (total_gr >= 0 && total_gr <= 249) {
      spreadValue = 0.05;
    } else if (total_gr >= 250 && total_gr <= 499) {
      spreadValue = 0.04;
    } else if (total_gr >= 500 && total_gr <= 999) {
      spreadValue = 0.03;
    } else if (total_gr >= 1000) {
      spreadValue = 0.02;
    }

    if(total_gr < 1000 && duration === 1) {
      duration = 5
    }

    if (duration === 1 && total_gr >= 1000) {
      storageValue = 0.03;
    } else if (duration === 10) {
      storageValue = 0.125;
    } else {
      storageValue = 0.075;
    }

    totalManufacturingCost = hOneDettaglios.reduce(
      (total, item) => total + item.manufacturingCost,
      0
    );

    goldCost = hOneDettaglios.reduce((total, item) => total + item.goldCost, 0);
    storageCost = goldCost * storageValue;
    if (homeDelivery) {
      spreadValue = spreadValue * 2;
      // totalManufacturingCost = 0;
      storageCost = 0
    }
    costSpread = goldCost * spreadValue;
    totalCost = goldCost + costSpread + storageCost + totalManufacturingCost;

    const guaranteeMargin = Number(inputData.guaranteeMargin) / 100;
    goldPriceWithGuaranteeMargin = goldCost *  guaranteeMargin;
    costSpreadWithGuaranteeMargin = costSpread * guaranteeMargin;
    storageCostWithGuaranteeMargin = storageCost * guaranteeMargin;
    total_payment_with_guarantee_margin = goldPriceWithGuaranteeMargin + costSpreadWithGuaranteeMargin + storageCostWithGuaranteeMargin;
    
    if(inputData.paymentMethod) {
      const txValue = BANK_PAYMENT_METHODS.includes(inputData.paymentMethod) ? inputData.txBankFee : inputData.txCryptoFee;
      const margin = Number(txValue) / 100;
      goldPriceWithMargin = goldCost * margin;
      costSpreadWithMargin = costSpread * margin;
      storageCostWithMargin = storageCost * margin;
      total_payment_with_margin = goldPriceWithMargin + costSpreadWithMargin + storageCostWithMargin;
    }
    bank_transfer = totalCost + total_payment_with_margin + total_payment_with_guarantee_margin;
  }

  return {
    ...inputData,
    ingots: hOneDettaglios,
    duration,
    goldCost,
    storageValue,
    storageCost,
    spreadValue,
    spreadCost: costSpread,
    totalManufacturingCost,
    totalCost,
    totalGrams: total_gr,
    goldPriceWithMargin,
    costSpreadWithMargin,
    storageCostWithMargin,
    goldPriceWithGuaranteeMargin,
    costSpreadWithGuaranteeMargin,
    storageCostWithGuaranteeMargin,
    manufacturingCostWithMargin,
    total_payment_with_margin,
    total_payment_with_guarantee_margin,
    bank_transfer,
  };
};

export const selectColourStyles2 = {
  container: (styles) => ({
    ...styles,
    width: "300px",
  }),
  option: (styles) => {
    return {
      ...styles,
      color: "#000",
    };
  },
};

const ENGLISH_MONTH_TO_INDEX = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};

export const getMonthIndexFromEnglishName = (monthName) => {
  if (!monthName || typeof monthName !== "string") return null;
  const key = monthName.trim().toLowerCase();
  if (!Object.prototype.hasOwnProperty.call(ENGLISH_MONTH_TO_INDEX, key)) return null;
  return ENGLISH_MONTH_TO_INDEX[key];
};

export const formatProductionMonthLabel = ({ month, year, locale }) => {
  const monthIndex = getMonthIndexFromEnglishName(month);
  if (monthIndex === null) return `${month} ${year}`;

  const safeYear = Number(year);
  if (!Number.isFinite(safeYear)) return `${month} ${year}`;

  const date = new Date(Date.UTC(safeYear, monthIndex, 1));
  const dtf = new Intl.DateTimeFormat(locale || "en", { month: "long" });
  const localizedMonth = dtf.format(date);

  const labelMonth = localizedMonth
    ? localizedMonth.charAt(0).toUpperCase() + localizedMonth.slice(1)
    : month;

  return `${labelMonth} ${year}`;
};

export const formatToCHF = (amount, rate) => {
  if(!amount || !rate) return amount;
  return (amount / rate).toFixed(6);
}

export const sortProductionMonthaData = (data) => {
  // Get the current month and year
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const sortedData = [...data].sort((a, b) => {
    const aYear = a.year;
    const bYear = b.year;
    const aMonth = monthOrder[a.month];
    const bMonth = monthOrder[b.month];

    // Prioritize the current month and year first (descending order)
    if (aYear === currentYear && aMonth === currentMonth) return -1;  // Move current month to the top
    if (bYear === currentYear && bMonth === currentMonth) return 1;

    // Otherwise, sort by year and month in descending order
    if (aYear === bYear) {
      return bMonth - aMonth;  // Reverse the comparison for descending order
    }
    return bYear - aYear;  // Reverse the comparison for descending order
  })
  // Remove duplicates by checking combinations of year and month
  .filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.month === value.month && t.year === value.year
    ))
  );

  return sortedData;
};

export const hPlanCalculation = (data) => {
  let {
    initialPaymentNumber,
    recurringPaymentAmount,
    recurringPaymentNumber,
    docSplit,
    discountCode,
    paymentMethod,
    txBankFee,
    txCryptoFee,
    txFeeCC
  } = data;

  let initialPaymentAmount = 0;
  let totalRecurringAmount = 0;
  let dossierOpeningCharge = 0;
  let docSplitAmount = 0;
  let totalPayment = 0;
  let totalPaymentWithTX = 0;
  let appliedCode = discountCode;
  let message = { text: "", type: "" };

  initialPaymentAmount = initialPaymentNumber * recurringPaymentAmount;
  totalRecurringAmount = recurringPaymentAmount * recurringPaymentNumber;
  dossierOpeningCharge = totalRecurringAmount / 10;
  totalPayment = dossierOpeningCharge + initialPaymentAmount;

  if (docSplit && dossierOpeningCharge < 4800) {
    message = { text: "docCantDivided", type: "error" };
    docSplit = false;
  }
  if (docSplit && dossierOpeningCharge > 4800) {
    docSplitAmount = dossierOpeningCharge / 2;
    totalPayment = docSplitAmount + initialPaymentAmount;
  }

  if (discountCode && dossierOpeningCharge >= 2000) {
    let discountPercentage = 0;
    if (discountCode === "CS10") {
      appliedCode = "CS10";
      discountPercentage += 0.1;
    }

    if (discountCode === "CS5") {
      appliedCode = "CS5";
      discountPercentage += 0.05;
    }

    if (
      discountPercentage !== 0 &&
      dossierOpeningCharge >= 6000 &&
      dossierOpeningCharge < 12000
    ) {
      message = { text: "extra5Discount", type: "success" };
      appliedCode = discountCode + "+5";
      discountPercentage += 0.05;
    }
    if (discountPercentage !== 0 && dossierOpeningCharge >= 12000) {
      message = { text: "extra10Discount", type: "success" };
      appliedCode = discountCode + "+10";
      discountPercentage += 0.1;
    }

    // console.log({discountPercentage, appliedCode})

    if (docSplit) {
      totalPayment = totalPayment - docSplitAmount * discountPercentage;
    } else {
      totalPayment = totalPayment - dossierOpeningCharge * discountPercentage;
    }
  }
  
  let txFee = 0;
  if (paymentMethod) {
    const txValue = BANK_PAYMENT_METHODS.includes(paymentMethod) ? paymentMethod.toLowerCase() === "credit card" ? txFeeCC : txBankFee : txCryptoFee
    txFee = Number(txValue) / 100;
  }

  totalPaymentWithTX = totalPayment + +totalPayment * txFee;

  const result = {
    ...data,
    initialPaymentNumber,
    initialPaymentAmount,
    totalRecurringAmount,
    dossierOpeningCharge,
    docSplitAmount,
    totalPayment,
    totalPaymentWithTX,
    discountCode,
    appliedCode,
    docSplit,
    message,
  };

  return result;
};

export const flattenUsers = (users, result = []) => {
  // Iterate through the array of users
  users.forEach((user) => {
    // Add current user to the result array
    result.push(user);

    // If the user has a downline, recurse into it
    if (user.downline && user.downline.length > 0) {
      flattenUsers(user.downline, result);
    }
  });

  return result;
};

export const truncateString = (str, len) => {
  if (str.length > 15) {
    return str.substring(0, len) + "...";
  }
  return str;
};

export const flattenHierarchy = (data) => {
  let result = [];
  const flattenUsers = (node, parentId, level = 1) => {
    let newNode = {
      id: node.user_id,
      referral_code: node.referral_code || "",
      name: node?.name ?? node?.user?.first_name + " " + node?.user?.last_name,
      status: node.status || "",
      email: node.email || node.user.email || "",
      parentId: parentId || "",
      totalDOC: node?.totalDOC || node?.total_doc || "",
      earnedCommission: node?.earnedCommission || "",
      restCommission: node?.restCommission || "",
      qualification: node?.qualification || "-",
      affiliateCode: node?.affiliate_code || "-",
      clients: node?.numberOfClients || 0,
      level: level - 1,
    };
    result.push(newNode);

    if (node.downline && node.downline.length > 0) {
      node.downline.forEach((child) => {
        flattenUsers(child, node.user_id, level + 1);
      });
    }
  };

  const parentId = data?.upline?.user_id || "";
  flattenUsers(data, parentId, 1);
  return result;
};

export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%?]).{8,24}$/i;
export const lettersWithSpaces = /^[a-zA-ZàèéìòùáóíÓÆæŒœ.\-,:_'\s]+$/;
export const alphanumericNoSpaces = /^[0-9a-zA-ZàèéìòùáóíÓÆæŒœ.\-,:_']+$/;
export const alphanumericWithSpaces = /^[0-9a-zA-ZàèéìòùáóíÓÆæŒœ.\-,:_'\s/]+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const regInitialValues = {
  collaborator: null,
  email: "",
  password: "",
  confirmPassword: "",
  type: "",
  taxCode: "",
  pec: "",
  affiliateCode: "",
  vatNumber: "",
  name: "",
  surName: "",
  dateOfBirth: "",
  sex: "",
  placeOfBirth: "",
  provinceOfBirth: "",
  mobilePhone: "",
  telephone: "",
  address: "",
  city: "",
  province: "",
  postcode: "",
  addressHome: "",
  cityHome: "",
  provinceHome: "",
  postcodeHome: "",
  language: "en",
  roleId: "9",
  acceptCodeOfEthics: false,
  acceptCompensationPlan: false,
  acceptConfidentialityAgreement: false,
  term_1: "",
  term_1_answer: "",
  interviewedPersonSurname: "",
  acceptPrivacyPolicy: false,
  acceptTermsConditions: false,
  companyName: "",
};

export const addUserInitialValues = {
  email: "",
  password: "",
  confirmPassword: "",
  type: "",
  taxCode: "",
  pec: "",
  vatNumber: "",
  name: "",
  surName: "",
  dateOfBirth: "",
  affiliateCode: "",
  sex: "",
  placeOfBirth: "",
  provinceOfBirth: "",
  mobilePhone: "",
  telephone: "",
  address: "",
  city: "",
  province: "",
  postcode: "",
  addressHome: "",
  cityHome: "",
  provinceHome: "",
  postcodeHome: "",
  language: "en",
  roleId: 9,
  acceptPrivacyPolicy: true,
};

export const planData = [
  {
    type: "Monthly",
    recurringAmount: [
      100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750,
      1000, 1250, 1500, 1750, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500,
      6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000,
      11500, 12000, 12500, 13000, 13500, 14000, 14500, 15000, 15500, 16000,
      16500, 17000, 17500, 18000, 18500, 19000, 19500, 20000, 20500, 21000,
      21500, 22000, 22500, 23000, 23500, 24000, 24500, 25000,
    ],
    minRecurringPaymentNumber: 60,
    maxRecurringPaymentNumber: 420,
  },
  {
    type: "Bimonthly",
    // recurringAmount: [
    //   200, 400, 800, 1000, 2500, 3000, 3500, 4000, 5000, 6000, 8000, 10000,
    // ],
    recurringAmount: [
      200, 400, 800, 1000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500,
      7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000,
      12500, 13000, 13500, 14000, 14500, 15000, 15500, 16000, 16500, 17000,
      17500, 18000, 18500, 19000, 19500, 20000, 20500, 21000, 21500, 22000,
      22500, 23000, 23500, 24000, 24500, 25000,
    ],
    minRecurringPaymentNumber: 30,
    maxRecurringPaymentNumber: 210,
  },
  {
    type: "Quarterly",
    // recurringAmount: [
    //   300, 600, 900, 1200, 1500, 3750, 4500, 5250, 6000, 7500, 9000, 12000,
    //   15000,
    // ],
    recurringAmount: [
      300, 600, 900, 1200, 1500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500,
      7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000,
      12500, 13000, 13500, 14000, 14500, 15000, 15500, 16000, 16500, 17000,
      17500, 18000, 18500, 19000, 19500, 20000, 20500, 21000, 21500, 22000,
      22500, 23000, 23500, 24000, 24500, 25000,
    ],
    minRecurringPaymentNumber: 20,
    maxRecurringPaymentNumber: 140,
  },
];

export const initialHPPurchaseData = {
  periodicityOfPayment: "",
  recurringPaymentAmount: 0,
  recurringPaymentNumber: 0,
  initialPaymentNumber: 0,
  initialPaymentAmount: 0,
  acceptTNC: false,
  P01: false,
  P02: false,
  P03: false,
  P04: false,
  P05: false,
  P06: false,
  P07: false,
  P08: false,
  C01: false,
  C02: false,
  C03: false,
  B01: false,
  B02P: false,
  B03: false,
  acceptBlockchain: false,
  paymentMethod: "",
  totalRecurringAmount: "",
  dossierOpeningCharge: "",
  totalPayment: 0,
  docSplit: false,
  docSplitAmount: 0,
  ingot: "50",
  discountCode: "",
  appliedCode: "",
  stampDuty: 0,
  txCryptoFee: 0,
  guaranteeMargin: 0,
  currency: "CHF"
};

export const initialHOneInputData = {
  goldPriceWithMargin: 0,
  costSpreadWithMargin: 0,
  storageCostWithMargin: 0,
  total_payment_with_margin: 0,
  bank_transfer: 0,
  duration: 5,
  goldCost: 0,
  storageValue: 0,
  storageCost: 0,
  spreadValue: 0,
  spreadCost: 0,
  totalManufacturingCost: 0,
  totalCost: 0,
  totalGrams: 0,
  type: "custody",
  acceptTNC: false,
  O01: false,
  O02: false,
  O03: false,
  O04: false,
  C01: false,
  C02: false,
  C03: false,
  B01: false,
  B02O: false,
  B03: false,
  acceptBlockchain: false,
  paymentMethod: "",
  manufacturingCostWithMargin: 0,
  ingots: [
    // { ingot: 10, quantity: 0, manufacturingCost: 0, goldCost: 0, totalCost: 0 },
    { ingot: 50, quantity: 0, manufacturingCost: 0, goldCost: 0, totalCost: 0 },
    {
      ingot: 100,
      quantity: 0,
      manufacturingCost: 0,
      goldCost: 0,
      totalCost: 0,
    },
    {
      ingot: 250,
      quantity: 0,
      manufacturingCost: 0,
      goldCost: 0,
      totalCost: 0,
    },
    {
      ingot: 500,
      quantity: 0,
      manufacturingCost: 0,
      goldCost: 0,
      totalCost: 0,
    },
    {
      ingot: 1000,
      quantity: 0,
      manufacturingCost: 0,
      goldCost: 0,
      totalCost: 0,
    },
  ],
  stampDuty: 0,
  txCryptoFee: 0,
  guaranteeMargin: 0,
  currency: "CHF"
};

export const formatTransactionId = (txId) => {
  // Check if the transaction ID is at least 8 characters long
  if (txId?.length < 8) {
    throw new Error("Transaction ID must be at least 8 characters long");
  }

  // Extract the first 4 characters, last 4 characters, and add 4 asterisks in between
  const formattedId = txId === null ? "-" : txId?.slice(0, 4) + "****" + txId?.slice(-4);

  return formattedId;
};


export const userSchemaObject = {
  type: yup.string().required("typeRequired"),
  taxCode: yup
    .string()
    // .required("taxCodeRequired")
    .matches(alphanumericNoSpaces, "specialCharacterNotAllowed"),
  name: yup
    .string()
    .required("firstnameRequired")
    .matches(lettersWithSpaces, "specialCharacterNotAllowed"),
  surName: yup
    .string()
    .required("lastnameRequired")
    .matches(lettersWithSpaces, "specialCharacterNotAllowed"),
  dateOfBirth: yup
    .string()
    .required("dobRequired")
    .test("is-adult", "dobUnderAge", function (value) {
      const currentDate = new Date();
      const dob = new Date(value);
      const minAgeDate = new Date(
        currentDate.getFullYear() - 18,
        currentDate.getMonth(),
        currentDate.getDate()
      );
      return dob <= minAgeDate;
    }),
  sex: yup.string().required("sexRequired"),
  placeOfBirth: yup.string().required("birthPlaceRequired"),
  provinceOfBirth: yup.string().required("birthCountryRequired"),
  mobilePhone: yup
    .string()
    .test("is-valid-phone", "invalidPhoneNumber", (value) => {
      return !value || isValidPhoneNumber(value);
    })
    .required("mobileNumberRequired"),
  address: yup
    .string()
    .required("residenceAddressRequired")
    .matches(alphanumericWithSpaces, "specialCharacterNotAllowed"),
  city: yup
    .string()
    .required("residenceCityRequired")
    .matches(lettersWithSpaces, "specialCharacterNotAllowed"),
  province: yup.string().required("residenceCountryRequired"),
  postcode: yup
    .string()
    .required("residencePostcodeRequired")
    .matches(alphanumericNoSpaces, "specialCharacterNotAllowed"),
  addressHome: yup
    .string()
    .required("domicileAddressRequired")
    .matches(alphanumericWithSpaces, "specialCharacterNotAllowed"),
  cityHome: yup
    .string()
    .required("domicileCityRequired")
    .matches(lettersWithSpaces, "specialCharacterNotAllowed"),
  provinceHome: yup.string().required("domicileCountryRequired"),
  postcodeHome: yup
    .string()
    .required("domicilePostcodeRequired")
    .matches(alphanumericNoSpaces, "specialCharacterNotAllowed"),
  acceptPrivacyPolicy: yup.boolean().oneOf([true], "this_is_required"),
  acceptTermsConditions: yup.boolean().when("roleId", {
    is: "10",
    then: () => yup.boolean().oneOf([true], "this_is_required"),
  }),
};

export const updateUserSchema = yup.object().shape({
  ...userSchemaObject,
});

export const capitalizeFirstLetter = (str) => {
  if (!str) return ""; // return empty string if str is empty
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const convertToCSV = (data) => {
  if (!data || data.length === 0) return '';


  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','), // Header row
    ...data.map(row =>
      headers.map(header => {
        const value = row[header] || '';
        // Escape quotes and wrap in quotes if contains comma or quotes
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',')
    )
  ];


  return csvRows.join('\n');
};


export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);


  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';


  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);


  URL.revokeObjectURL(url);
};

export const compensationTableData = [
  {
    level: 1,
    title: "Iron",
    doc: "500.000",
    maxDoc: "250.000",
    desc: "10 collab",
    value: 20,
    text: "0.1% ric",
    capColor: "#595959",
  },
  {
    level: 2,
    title: "Steel",
    doc: "1.000.000",
    maxDoc: "500.000",
    desc: "20 collab",
    value: 30,
    text: "0.2% ric",
    capColor: "#D9D9D9",
  },
  {
    level: 3,
    title: "Bronze",
    doc: "2.500.000",
    maxDoc: "1.250.000",
    desc: "40 collab",
    value: 40,
    text: "0.3% ric",
    capColor: "#b08d57",
  },
  {
    level: 4,
    title: "Silver",
    doc: "5.000.000",
    maxDoc: "2.500.000",
    desc: "80 collab",
    value: 50,
    text: "0.4% ric",
    capColor: "#9A9A9A",
  },
  {
    level: 5,
    title: "Gold",
    doc: "10.000.000",
    maxDoc: "5.000.000",
    desc: "150 collab",
    value: 60,
    text: "0.5% ric",
    capColor: "#946D42",
  },
];

export const endRowTemplate = [
  {
    title: "activityStatus",
    items: [
      {
        title: "academyRegistration",
        status: "active",
      },
      {
        title: "presenceAtWebinars",
        status: "inactive",
      },
      {
        title: "rightToOvers",
        value: "11-2024",
      },
    ],
  },
  {
    title: "contestStartUp",
    items: [
      {
        title: "firstMonth",
        status: "active",
      },
      {
        title: "secondMonth",
        status: "inactive",
      },
    ],
  },
  {
    title: "personalIncentivePlan",
    items: [
      {
        title: "incentiveDeadline",
        value: "-43 days",
      },
    ],
  },
  {
    title: "discountCoupons",
    items: [
      {
        title: "toBeUsed",
        value: [],
      },
    ],
  },
  // {
  //   title: "autumContest",
  //   items: [
  //     {
  //       title: "docMissingFromPrize",
  //       value: "-12.500",
  //     },
  //   ],
  // },
];